'use strict';

/**
 * authInterceptor — refresh transparente en 401 para sesiones JWT.
 *
 * Si un request autenticado con JWT (token "eyJ...") recibe 401 y hay refreshToken,
 * llama a /oauthrefresh/ (vía TokenRefresh, singleton) y REINTENTA el request original
 * una sola vez con el token nuevo. Si el refresh falla, rechaza y cae al manejo de 401
 * existente del factory Request (desloguear -> signin).
 *
 * Sesiones UUID (sin refreshToken) o sin JWT no se tocan: comportamiento legacy intacto.
 *
 * Usa $injector.get para resolver $http/TokenRefresh y evitar la dependencia circular
 * (un interceptor de $http no puede depender de $http directamente).
 */
angular.module("ufcw")

.factory('authInterceptor', ['$q', '$injector', '$localstorage', function($q, $injector, $localstorage) {
  return {
    responseError: function(rejection) {
      var config = (rejection && rejection.config) || {};
      var url = config.url || '';
      var isRefreshCall = url.indexOf('oauthrefresh') !== -1;
      var hasRefreshToken = !!$localstorage.get('refreshToken');
      var isJwt = ('' + ($localstorage.get('token') || '')).indexOf('eyJ') === 0;

      if (rejection.status === 401 && hasRefreshToken && isJwt && !isRefreshCall && !config.__retried) {
        var TokenRefresh = $injector.get('TokenRefresh');
        var $http = $injector.get('$http');
        return TokenRefresh.refresh().then(function(newToken) {
          config.__retried = true;
          config.headers = config.headers || {};
          config.headers.Authorization = 'Bearer ' + newToken;
          return $http(config);
        }).catch(function() {
          return $q.reject(rejection);
        });
      }

      return $q.reject(rejection);
    }
  };
}])

.config(['$httpProvider', function($httpProvider) {
  $httpProvider.interceptors.push('authInterceptor');
}]);
